module.exports = __webpack_public_path__ + "static/media/icon-line-chart.71a6d035.svg";